/** Navitaire queues that indicate an involuntary (disruption) change — see involuntary changes ticket. */
export const INVOLUNTARY_CHANGE_QUEUE_CODES = [
  "DEVTOT",
  "EXPCH",
  "TIMPD1",
  "TIMPD2",
  "TIMPD3",
] as const;

export type InvoluntaryChangeQueueCode = (typeof INVOLUNTARY_CHANGE_QUEUE_CODES)[number];

export function isInvoluntaryChangeFromQueues(queues?: { code?: string | null }[] | null): boolean {
  if (!queues?.length) {
    return false;
  }

  return queues.some((queue) =>
    INVOLUNTARY_CHANGE_QUEUE_CODES.includes((queue.code ?? "") as InvoluntaryChangeQueueCode),
  );
}
